<template>
  <sdn-banner :sdnData="sdnData" />
</template>

<script>
  import { mapActions } from 'vuex'
  import SdnBanner from './sdn_notification_banner'

  export default {
    props: {
      sdnData: {
        type: Object
      }
    },
    components: {
      SdnBanner
    },
    mounted() {
      this.loadNotifications({ type: 'sdn', limit: 1, mark_read: false })
    },
    methods: {
      ...mapActions(['loadNotifications']),
    }
  }
</script>
